//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ohDirectDelivery', {
//        templateUrl: 'views/components/views/ohDirectDelivery/ohDirectDelivery.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'ohDirectDeliveryService', function ($stateParams, stateService, translateService, modalService, ohDirectDeliveryService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderInternalNo = $stateParams.order_internal_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                showSelectAll: false,
//                showUnSelectAll: false,
//                amountPaidBeforeButtons: [
//                    {
//                        id: 'goto',
//                        icon: 'fa fa-chevron-right',
//                        color: 'primary',
//                        type: 'primary',
//                        onClick: () => stateService.go('prepayments', {
//                            argtype: 'order_internal_no',
//                            argvalue: vm.model.setting.order_internal_no
//                        })
//                    }
//                ],
//                setting: {},
//                itemsListDirectDeliveries: [],
//                lockedDelivery: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await ohDirectDeliveryService.getSetting({ order_internal_no: orderInternalNo }))[0];
//            }

//            async function loadDirectDeliveries() {
//                vm.model.itemsListDirectDeliveries = (await ohDirectDeliveryService.listDirectDeliveries(vm.model.setting));

//                vm.model.itemsListDirectDeliveries.forEach((item) => {
//                    if (item.item_id === '0' || item.item_id === '-1') return;

//                    if (item.item_is_selected === '1') {
//                        vm.model.showSelectAll = false;
//                        vm.model.showUnSelectAll = true;
//                    } else {
//                        vm.model.showSelectAll = true;
//                        vm.model.showUnSelectAll = false;
//                    }
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TOGGLE FUNCTIONS
            
//            vm.toggleChosen = function (item) {
//                item = item?.item ? item.item : item;
                
//                if (item.item_id === '0' || item.item_id === '-1') return;
                
//                if (item.item_is_selected === '0') {
//                    item.item_is_selected = '1';
//                } else if (item.item_is_selected === '1') {
//                    item.item_is_selected = '0';
//                }
//            }
            
//            vm.selectAll = function () {
//                vm.model.itemsListDirectDeliveries.forEach((item) => {
//    				if (item.item_id === '0' || item.item_id === '-1') return;
                    
//                    item.item_is_selected = '1';
//                    vm.model.showSelectAll = false;
//                    vm.model.showUnSelectAll = true;
//    			});
//    		}
            
//    		vm.unselectAll = function () {
//                vm.model.itemsListDirectDeliveries.forEach((item) => {
//    				if (item.item_id === '0' || item.item_id === '-1') return;
                    
//                    item.item_is_selected = '0';
//                    vm.model.showSelectAll = true;
//                    vm.model.showUnSelectAll = false;
//    			});
//    		}

//            // #endregion TOGGLE FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.deliverChanges = function () {
//                vm.model.lockedDelivery = true;
//                let selectedItems = [];

//                vm.model.itemsListDirectDeliveries.forEach((item) => {
//                    if (item.item_id === '0' || item.item_id === '-1') return;

//                    selectedItems.push({
//                        item_id: item.item_id,
//                        item_name: item.item_name,
//                        item_is_selected: item.item_is_selected
//                    });
//                });

//                ohDirectDeliveryService.deliverObj({
//                    order_internal_no: vm.model.setting.order_internal_no,
//                    records: selectedItems
//                }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                                    vm.model.lockedDelivery = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                        vm.model.lockedDelivery = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadDirectDeliveries();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
